import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { FormCoverages } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepThreeFormContext } from '../../../../../StepThree/contexts/StepThreeForm';

export const PropertyDataSection = () => {
  const { consortiumQuotationComponents } = useContext(StepThreeFormContext);

  const [activeTab, setActiveTab] = useState<any>(
    consortiumQuotationComponents[0]?.nroComponente
  );
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = consortiumQuotationComponents.map(
      (consortiumComponent, index: number) => ({
        children: (
          <FormCoverages
            key={`${consortiumComponent.codPlan}-${index}`}
            consortiumComponent={consortiumComponent}
          />
        ),
        closable: false,
        forceRender: true,
        key: consortiumComponent.nroComponente,
        label: `Integral de Consorcio ${consortiumComponent.nroComponente}`,
      })
    );

    setTabs(newTabs);
  }, [consortiumQuotationComponents, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
